import React from 'react'

const Bone: React.FC<{ h?: number; w?: string; mb?: number }> = ({ h = 18, w = '100%', mb }) => (
  <span
    className='placeholder rounded'
    style={{ display: 'block', height: h, width: w, marginBottom: mb }}
  />
)

export const TabSkeleton: React.FC = () => (
  <div className='placeholder-glow'>
    <div className='card mt-10 p-5'>
      <Bone h={28} w='220px' />
    </div>
    <div className='card mt-10 p-10'>
      <Bone h={18} w='160px' mb={20} />
      <Bone h={42} mb={12} />
      <Bone h={42} mb={12} />
      <Bone h={42} />
    </div>
    <div className='card mt-10 p-10'>
      <Bone h={18} w='130px' mb={20} />
      <Bone h={42} mb={12} />
      <Bone h={42} />
    </div>
    <div className='card mt-10 p-10'>
      <Bone h={18} w='150px' mb={20} />
      <Bone h={100} />
    </div>
  </div>
)
